<template>
  <div>
    <div class="columnfun">
      <!-- <h1>
        OMG
      </h1> -->
      <!-- <yo cta="Yo!" :ownerID="'5d13232864ca6d0017a77b94'" :earthID="'5d13232864ca6d0017a77b95'" :styler="{ fontSize: '15px', width: '60px', lineHeight: '60px', height: '60px',  borderRadius: '60px', position: 'absolute', bottom: '-15px', right: '-20px' }"></yo> -->
      <yo cta="Yo!" :ownerID="'5d14608021fc550017b988cd'" :earthID="'5d14608121fc550017b988ce'"></yo>

      <!-- <yo :room="'wonglok7'"></yo> -->
      <!-- <Yo :marker="'buhk'" :userData="yodata" :room="slugify(`${yodata.title}${yodata.roomID}`)" :cta="'Chat'" :styler="{ fontSize: '15px', width: '60px', lineHeight: '60px', height: '60px',  borderRadius: '60px', position: 'absolute', bottom: '0px', right: '0px' }"></Yo> -->

      <!-- <div v-if="builder">
        <h1>
          Test Run
        </h1>

        <div>
          <yo :room="builder.roomName"></yo>
        </div>

        <h1>
          Copy and Paste Into Edx or WordPress
        </h1>
        <textarea v-model="builder.code">
        </textarea>
      </div> -->
    </div>

  </div>
</template>

<script>
import { API } from '@/yoteach2-gui/parts/index.js'
import _ from 'lodash'
import slugify from 'slugify'

export default {
  slugify,
  API,
  _,
  components: {
    Yo: require('../widget/yo.vue').default,
    yo: require('../widget/yo.vue').default
  },
  data () {
    return {
      /* eslint-disable */
      // yodata: {
      //   "roomID": "-Lhe-wDfi362oKLg-Kjs",
      //   "roomNum": 6,
      //   "sizeX": 75,
      //   "sizeY": 75,
      //   "title": "loktest2",
      //   "trashed": false,
      //   "type": "user-games",
      //   "userID": "KKy7FOUgiFYkxbQr9VUQVe11Y3k2",

      //   "_id": "-LfZSmdEn-Zi1FKyMLAh",
      //   "marker": "buhk",
      //   "YoRooms": {
      //     "-LheOoMpA_5iPONo0OAo": {
      //       "enabled": true,
      //       "roomSlug": "Team_ABC___LheOoMpA_5iPONo0OAo",
      //       "roomTitle": "Team ABC "
      //     }
      //   },
      //   "enableEntryPassword": true,
      //   "entryPassword": "1234",
      //   "easyQuestion": "EasyMath",
      //   "hardQuestion": "HardMath",
      //   "mediumQuestion": "MediumMath",
      //   "pinned": true,
      //   "myInfo": {
      //     "displayName": "Lok Lok",
      //     "gameID": "-LfZSmdEn-Zi1FKyMLAh",
      //     "gameInfo": {
      //       "cellCore": {
      //         "belongsTo": "KKy7FOUgiFYkxbQr9VUQVe11Y3k2",
      //         "color": {
      //           "b": 0.35769113783218,
      //           "g": 1,
      //           "r": 0
      //         },
      //         "numID": 2661,
      //         "toBeRemoved": false,
      //         "xid": 36,
      //         "yid": 35
      //       }
      //     },
      //     "myColor": "#00ff5b",
      //   }
      // },
      /* eslint-enable */
      // query: '',
      // roomList: [],
      builder: false
    }
  },
  watch: {
    // query () {
    //   this.search({ title: this.query || '_  _  _' })
    // }
  },
  methods: {
    // slugify (title) {
    //   return slugify(title, {
    //     replacement: '_',
    //     remove: new RegExp(`!`, 'i')
    //   })
    // },
    // search: _.debounce(function ({ title }) {
    //   API.searchRoom({ title })
    //     .then((resp) => {
    //       this.roomList = resp.data
    //     })
    // }, 600),
    // build ({ room }) {
    //   let roomName = room.title
    //   this.builder = false
    //   this.$nextTick(() => {
    //     this.builder = {
    //       code: this.buildCode({ roomName: roomName }),
    //       roomName: roomName
    //     }
    //   })
    // },
    // buildCode ({ roomName }) {
    //   /* eslint-disable */
    //   let code = require('raw-loader!./yoearth-code.txt').default
    //   code = code.replace('<!--room-->', roomName)
    //   let r = '_' + Number(Math.random() * 100000).toFixed(0)
    //   code = code.replace('<!--r-->', r)
    //   code = code.replace('<!--r-->', r)
    //   code = code.replace('<!--r-->', r)
    //   code = code.replace('<!--r-->', r)
    //   code = code.replace('<!--r-->', r)
    //   return code
    //   /* eslint-enable */
    // }
  }
}
</script>

<style scoped>
.columnfun{
  width: calc(100% - 30px);
  max-width: 1200px;
  margin: 0px auto;
}
</style>
